import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import * as R from 'ramda';
import { useAppDispatch } from '../../../../hooks/hooks';
import { selectDbnpListItems } from '../../../../redux/dbnp/selector';
import { selectglobalDBNPMappinQueryItems } from '../../../../redux/dbnp-mappings/selector';
import { globalDBNPMappings } from '../../../../redux/dbnp-mappings/action';
import { dbnp } from '../../../../redux/dbnp/action';
import PageLoader from '../../../../components/PageLoader';
import DbnpMappingComponent from '../components/global-dbnp-mapping.component';


const DbnpMapping = () => {   
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const dbnpMappingQuery = useSelector(selectglobalDBNPMappinQueryItems)
  const dbnpItems = useSelector(selectDbnpListItems)
const [isQuery, setIsQuery] = useState<boolean>(false)
const [isLoading, setIsLoading] = useState<boolean>(true)
  const [
    selectedDbnpMapping,
    setSelectedDbnpMapping
  ] = useState<any>({})
 

  const fetchDbnpMappingById= ()=>{
    dispatch(globalDBNPMappings.query({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbnp-mappings/query`,entity:'globalDBNPMappings',jsonData:{
          
    Records: [
      {
        Id: parmas?.id
      }
    ]
  
}})).then(()=>{
  setIsQuery(true)
})

  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedDbnpMapping({ ...selectedDbnpMapping, [field]: event });
  }

  useEffect(
    () => {
        dispatch(dbnp.list({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/dbnp/list`,entity:'dbnp',jsonData:{
    }})).then(()=>{
            if (parmas?.id > 0) {
                fetchDbnpMappingById()
                setIsLoading(false)
              }else {
                setIsLoading(false)
              }
           
          })
    },
    []
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setSelectedDbnpMapping(dbnpMappingQuery?.result?.items)
      }
    },
    [isQuery]
  )
 
const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
    if (parmas?.id > 0) {
      await dispatch(globalDBNPMappings.resetAction({ actionType: 'update' }))
      await dispatch(globalDBNPMappings.update({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/dbn/dbnp-mappings`,entity:'globalDBNPMappings',jsonData:{
          
    Records: [
        selectedDbnpMapping
    ]
 
}})).then(()=>{
    back()
  })
  

    }else{
      await dispatch(globalDBNPMappings.resetAction({ actionType: 'create' }))
      await dispatch(globalDBNPMappings.create({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/dbn/dbnp-mappings`,entity:'globalDBNPMappings',jsonData:{
          
      Records: [
        selectedDbnpMapping
      ]
    
  }})).then(()=>{
    back()
  })
  
    }
   
    
  }

const back=()=>{
  navigate('/dbn/global-dbnp-mappings')
} 
const fetchDbnpList = (dbnpId: any) => {
    const status = R.find(
      (item: any) => parseInt(
        item.Id,
        10
      ) === parseInt(
        dbnpId,
        10
      ),
      dbnpItems?.result?.items
    )
    selectedDbnpMapping.IsDBNPConsumerEnabled = status?.IsJoinAsDBNConsumer
    selectedDbnpMapping.ISDBNPProviderEnabled = status?.IsJoinAsDBNProvider
    selectedDbnpMapping.IsDBNPSupplierRoleEnabled = status?.IsJoinAsDBNSupplier
    selectedDbnpMapping.IsDBNPVendorRoleEnabled = status?.IsJoinAsDBNVendor
    selectedDbnpMapping.IsDBNPPartnerRoleEnabled = status?.IsJoingAsDBNPartner
  }
    return (
    <>
     {isLoading ? <PageLoader /> : 
          <DbnpMappingComponent 
           id={parmas.id}
           onFormChange={handleInnerFormChange}
           dbnp ={dbnpItems?.result?.items}
           selectedDbnpMapping={selectedDbnpMapping}
           fetchDbnpList={fetchDbnpList}
           back={back}
           handleFormSubmit={handleFormSubmit}
          /> 
        } 
          </>
    )
    
    }
   
    export default DbnpMapping;